module.exports = __webpack_public_path__ + "static/bg-sec5-sm-2-6b314ef9087ae288c3740892f42765d6.jpg";